import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AbcDropDownBoxButtonComponent, AbcTextBoxComponent, _AbcButtonComponent } from '@barthauer/abc/ui-components';
import { DxLoadPanelModule } from 'devextreme-angular';
import { LayoutComponent } from './layout/layout.component';
import { NavHeaderComponent } from './navHeader/navHeader.component';
import { SearchBarComponent } from './searchBar/searchBar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { TopbarComponent } from './topbar/topbar.component';

@NgModule({
  imports: [CommonModule, _AbcButtonComponent, AbcTextBoxComponent, AbcDropDownBoxButtonComponent, DxLoadPanelModule],
  declarations: [LayoutComponent, TopbarComponent, SidebarComponent, SearchBarComponent, NavHeaderComponent],
  exports: [LayoutComponent, TopbarComponent, SidebarComponent, SearchBarComponent, NavHeaderComponent],
})
export class CoreModule {}
